import React, { FC } from 'react';

interface IProps {
  value: boolean;
  onChange: (value: boolean) => void;
  label: string;
  bgColor?: string;
  bgCheckedColor?: string;
  isRounded?: boolean;
  withCheckmark?: boolean;
  withoutGap?: boolean;
}

export const InputCheckbox: FC<IProps> = ({
  value,
  onChange,
  label,
  bgColor = '#141316',
  bgCheckedColor = '#189CD8',
  isRounded = false,
  withCheckmark = false,
  withoutGap = false,
}) => {
  return (
    <div className="flex items-center gap-[5px] justify-center">
      <div
        style={{
          backgroundColor: value && withoutGap ? bgCheckedColor : bgColor,
        }}
        onClick={() => onChange(!value)}
        className={`w-[16px] h-[16px] ${isRounded ? 'rounded-[50%]' : 'rounded-[5px] '} border border-solid border-[#373539] cursor-pointer flex items-center justify-center`}
      >
        {value && !withoutGap ? (
          <div
            className={`relative ${isRounded ? 'rounded-[50%]' : 'rounded-[3px] '} w-[10px] h-[10px]`}
            style={{ backgroundColor: `${bgCheckedColor}` }}
          >
            {withCheckmark ? (
              <span className="absolute top-[1px] left-[3px] w-[4px] h-[7px] border-b border-r rotate-45 border-[#141316]"></span>
            ) : null}
          </div>
        ) : null}
      </div>
      {label.length ? <div className="text-[14px]">{label}</div> : null}
    </div>
  );
};
